enum Theme {
  LIGHT = 'light',
  DARK = 'dark',
}

export default Theme;
